import React from 'react';
import { GraduationCap, Award, Users, Shield, School, Calendar, Heart } from 'lucide-react';

const CommunitySection = () => {
  const scrollToBooking = () => {
    if (window.location.pathname !== '/') {
      window.location.href = '/#book';
      return;
    }

    document.getElementById('book')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToSchools = () => {
    document.getElementById('schools')?.scrollIntoView({ behavior: 'smooth' });
  };

  const openContact = () => {
    window.location.href = 'mailto:wheels@kyledrive.co.uk';
  };

  const programs = [
    {
      icon: <GraduationCap className="w-6 h-6 kyle-icon-bounce kyle-icon-delay-1" />,
      title: "Future Drivers Scotland",
      description: "Young people from 10 years upwards",
      color: "from-cyan-500 to-blue-500",
      action: scrollToBooking
    },
    {
      icon: <Award className="w-6 h-6 kyle-icon-bounce kyle-icon-delay-2" />,
      title: "Learner Boost",
      description: "Confidence before test, less driving fear",
      color: "from-teal-500 to-cyan-500",
      action: scrollToBooking
    },
    {
      icon: <Shield className="w-6 h-6 kyle-icon-bounce kyle-icon-delay-3" />,
      title: "Back Behind The Wheel",
      description: "Rebuilding confidence after time away from driving",
      color: "from-blue-500 to-indigo-500",
      action: scrollToBooking
    },
    {
      icon: <Users className="w-6 h-6 kyle-icon-bounce kyle-icon-delay-1" />,
      title: "Mature Driver Assessment",
      description: "Voluntary reassessment for confidence",
      color: "from-purple-500 to-blue-500",
      action: openContact
    },
    {
      icon: <School className="w-6 h-6 kyle-icon-bounce kyle-icon-delay-2" />,
      title: "Schools Programme",
      description: "Road safety education for the next generation",
      color: "from-pink-500 to-purple-500",
      action: scrollToSchools
    },
    {
      icon: <Calendar className="w-6 h-6 kyle-icon-bounce kyle-icon-delay-3" />,
      title: "Road Safety Events",
      description: "Community events that make a difference",
      color: "from-orange-500 to-pink-500",
      action: openContact
    },
    {
      icon: <Heart className="w-6 h-6 kyle-icon-bounce kyle-icon-delay-1" />,
      title: "Community Open Days",
      description: "Come see what we do, meet the team",
      color: "from-red-500 to-orange-500",
      action: openContact
    }
  ];

  return (
    <section className="relative py-16 sm:py-20 bg-gradient-to-br from-slate-50 via-blue-50 to-cyan-50 overflow-hidden kyle-section-compact">
      {/* Depth accents */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-gradient-to-br from-cyan-200/30 to-transparent rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-gradient-to-tl from-teal-200/30 to-transparent rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 relative z-10">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-5 py-2 bg-gradient-to-r from-cyan-500 to-teal-500 text-white rounded-full text-sm font-black mb-6 shadow-xl">
            <span>🤝</span>
            <span>MORE THAN YOUNG DRIVERS</span>
          </div>
          <div className="flex items-center justify-center gap-4 mb-4 flex-wrap">
            <img
              src="/kyle-drive-logo.png"
              alt="Kyle Drive"
              className="h-16 sm:h-20 w-auto"
            />
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-[hsl(210,100%,12%)]">
              A Community Driving Centre
            </h2>
          </div>
          <p className="text-base sm:text-lg text-gray-700 max-w-2xl mx-auto leading-relaxed">
            Kyle Drive serves every driver in our community, from first-timers to experienced motorists.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-8">
          {programs.map((program, index) => (
            <button
              key={index}
              onClick={program.action}
              className="group bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-gray-100 hover:border-cyan-400 text-left cursor-pointer hover:scale-105"
            >
              <div className={`inline-flex p-3 rounded-xl bg-gradient-to-br ${program.color} mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg`}>
                <div className="text-white">{program.icon}</div>
              </div>
              <h3 className="text-lg font-black text-[hsl(210,100%,12%)] mb-2">
                {program.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {program.description}
              </p>
            </button>
          ))}
        </div>

        <div className="text-center bg-white rounded-2xl p-6 shadow-xl border-2 border-cyan-200">
          <p className="text-xl font-black text-cyan-600 italic">
            "Building Confidence — One Journey At A Time"
          </p>
        </div>
      </div>
    </section>
  );
};

export default CommunitySection;
